module.exports = __webpack_public_path__ + "img/trans-admin.eafcd14c.svg";